import SimonDataSignUp from '../footer/simondata-signup';
import YotpoSMS from '../footer/yotpo-sms';
import AttentiveEmailSignUp from '../footer/attentive-email-signup';
import AttentiveSMSSignUp from '../footer/attentive-sms-signup';

class DomaineInputSubmit extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.error = this.querySelector('[data-error]');
    this.errorText = this.error ? this.error.textContent : '';
    this.submit = this.querySelector('button[type="submit"]');
    this.form = this.querySelector('form');
    this.successMessage = this.querySelector('[data-success]');
    this.inputWrapper = this.querySelector('domaine-input');

    this.formAction = this.form.action;
    this.analyticsEvent = this.getAttribute('analytics-event');
    this.consentRequired = this.getAttribute('consent-required');
    this.attentiveEnabled = this.getAttribute('attentive-enabled') === 'true';

    this.handleNewsletterSubmit = this.handleNewsletterSubmit.bind(this);
    this.handleSMSSubmit = this.handleSMSSubmit.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setLoadingState(isLoading) {
    if (!this.submit) return;

    if (isLoading) {
      this.submit.disabled = true;
      this.originalText = this.submit.textContent;
      this.submit.textContent = 'Please wait';
      this.submit.classList.add('opacity-60', 'cursor-not-allowed', 'right-[50px]');
    } else {
      this.submit.disabled = false;
      this.submit.textContent = this.originalText || 'Submit';
      this.submit.classList.remove('opacity-60', 'cursor-not-allowed', 'right-[50px]');
    }
  }

  connectedCallback() {
    if (this.hasAttribute('data-newsletter-form')) {
      this.form.addEventListener('submit', this.handleNewsletterSubmit);
    } else if (this.hasAttribute('data-sms-form')) {
      this.form.addEventListener('submit', this.handleSMSSubmit);
    } else {
      this.addEventListener('submit', this.handleSubmit);
    }
  }

  disconnectedCallback() {
    if (this.hasAttribute('data-newsletter-form')) {
      this.form.removeEventListener('submit', this.handleNewsletterSubmit);
    } else if (this.hasAttribute('data-sms-form')) {
      this.form.removeEventListener('submit', this.handleSMSSubmit);
    } else {
      this.removeEventListener('submit', this.handleSubmit);
    }
  }

  async handleNewsletterSubmit(e) {
    e.preventDefault();
    this.setLoadingState(true);
    try {
      if (this.attentiveEnabled) {
        await AttentiveEmailSignUp(this.analyticsEvent, this.consentRequired);
      } else {
        await SimonDataSignUp(this.analyticsEvent, this.consentRequired);
      }
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleSMSSubmit(e) {
    e.preventDefault();
    this.setLoadingState(true);

    try {
      if (this.attentiveEnabled) {
        await AttentiveSMSSignUp();
      } else {
        await YotpoSMS();
      }
    } finally {
      this.setLoadingState(false);
    }
  }

  async handleSubmit(e) {
    e.preventDefault();
    // TODO: Might need to make this more flexible for multiple scenarios
    const formData = new FormData(this.form);
    const data = Object.fromEntries(formData);

    try {
      this.submit.disabled = true;
      const res = await fetch(this.formAction, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!res.ok) throw new Error('Network response was not ok');

      this.setAttribute('success', '');
      this.input.value = '';

      if (this.analyticsEvent) {
        Shopify.analytics.publish(this.analyticsEvent, data);
      }

      setTimeout(() => {
        this.removeAttribute('success');
      }, 3000);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error submitting form', error);
      this.inputWrapper.setAttribute('error', '');
    }
  }
}

customElements.define('domaine-input-submit', DomaineInputSubmit);
